<template>
    <a :href="item.link" :target="item.target" class="links linksmob">{{item.item}}</a>
</template>
<script>
export default {
    props:['item'],   
}
</script>
<style scoped>

@media (max-width: 384px) {
  
.links {
    margin-left: 0.5em;
    color: rgb(0, 0, 0);
    font-size: 10px;
    font-family: Segoe UI;
    transition: 1s;
}


}

@media (min-width: 385px) {

.links {
    margin-left: 1em;
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-family: Segoe UI;
    transition: 1s;
}

}



a:hover{
    text-decoration: none;
    color: #0876b6
}
</style>





// WEBPACK FOOTER //
// src/shared/menuTopo/linkMenu.vue